<template>
  <transition name="slide">
    <div class="responsive-container" v-if="isVisible">
      <div class="menu-items" v-on-clickaway="hideDropdown">
        <router-link :to="`/user/${userName}`" @click.native="hideDropdown" v-if="authenticated">
          Profile
        </router-link>
        <router-link to="/event/new/edit" @click.native="hideDropdown">
          Create Event
        </router-link>
        <router-link to="/my-events" @click.native="hideDropdown" v-if="authenticated">
          Event Dashboard
        </router-link>
        <router-link to="/account/edit" @click.native="hideDropdown" v-if="authenticated">
          Account Settings
        </router-link>
        <div class="bottom-divider"></div>
        <router-link to="/privacy" @click.native="hideDropdown()">
          Privacy Policy
        </router-link>
        <router-link to="/" @click.native="() => logout() && hideDropdown()" v-if="authenticated">
          Logout
        </router-link>
      </div>
    </div>
  </transition>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'ResponsiveDropdown',
  mixins: [clickaway],
  data() {
    return {
      isVisible: true,
    };
  },
  computed: {
    ...mapState('auth', ['authenticated']),
    ...mapState('user', ['userName']),
  },
  methods: {
    ...mapActions('auth', ['logout']),
    hideDropdownFinishAnimation() {
      this.$emit('hideDropdown');
    },
    async hideDropdown() {
      this.isVisible = false;
      const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
      await delay(500);
      this.hideDropdownFinishAnimation();
    },
  },
};

</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.responsive-container {
  position: fixed;
  background-color: white;
  cursor: pointer;
  width: 15rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.3);
  z-index: 25;
  top: 4rem;
  bottom: 0;
  transition: all .5s;
}

.slide-enter-active, .slide-leave-active {
  left: 0;
}

.slide-enter, .slide-leave-to {
  left: -17rem;
}

.menu-items {
  display: flex;
  flex-direction: column;
  border-radius: 0.25rem;
  text-align: left;
  height: 100%;
}

.menu-items > a {
  height: 2rem;
  line-height: 2rem;
  padding: 0.5rem 3rem;
  font-size: 1rem;
  text-decoration: none;
  color: black;
}

.bottom-divider {
  margin-top: auto;
  border: 1px solid lightgray;
}

</style>
